import {http,config} from './__http';

export default { 
    getBasket(callback, params){
        http.get(config.baseUrl()+'/basket', params).then(response=>{
            callback(response.data);
        }).catch(e =>{
            callback(e.response);
        });
    },

    addProductsToBasket(callback, params){
        http.post(config.baseUrl() + '/basket/addItems', params).then(response =>{
            callback(response.data);
        }).catch(e =>{
            callback(e.response);
        });
    },

    updateItemInBasket(callback, params){
        http.post(config.baseUrl() + '/basket/updateItem', params).then(response =>{
            callback(response.data);
        }).catch(e =>{
            callback(e.response);
        });
    },

    removeItemFromBasket(callback, params){
        http.delete(config.baseUrl() + '/basket/removeItem/' + params.productVariantId).then(response => {
            callback(response.data);
        }).catch(e =>{
            callback(e.response);
        });
    },

    validateBasket(callback, params){
        http.post(config.baseUrl() + '/basket/validate', params).then(response =>{
            callback(response.data);
        }).catch(e =>{
            callback(e.response);
        });
    },

    processBasket(callback, params){
        http.post(config.baseUrl() + '/basket/submit', params).then(response =>{
            callback(response.data);
        }).catch(e => {
            console.error(e);
            callback(e.response);
        });
    },

    switchBasket(callback){
        http.post(config.baseUrl() + '/basket/switch').then(response =>{
            callback(response.data);
        }).catch(e =>{
            callback(e.response);
        });
    }

}


// WEBPACK FOOTER //
// ./src/api/Basket.js